import type { KnowledgeScope } from '../constants/knowledgeScope'

const CHANNEL = 'kb-doc-sync'

export type KnowledgeDocSavedPayload = {
  type: 'kb-doc-saved'
  scope: KnowledgeScope
  folderId: number
  itemId: number
  indexJobId?: string
}

/** 新建/更新文档成功后通知其它标签页（列表页）刷新 */
export function publishKnowledgeDocSaved(
  payload: Omit<KnowledgeDocSavedPayload, 'type'>,
): void {
  const msg: KnowledgeDocSavedPayload = { type: 'kb-doc-saved', ...payload }

  if (typeof BroadcastChannel !== 'undefined') {
    try {
      const bc = new BroadcastChannel(CHANNEL)
      bc.postMessage(msg)
      bc.close()
    } catch {
      /* BroadcastChannel 不可用时忽略 */
    }
  }

  if (window.opener && !window.opener.closed) {
    window.opener.postMessage(msg, window.location.origin)
  }
}

export function subscribeKnowledgeDocSaved(
  listener: (payload: KnowledgeDocSavedPayload) => void,
): () => void {
  const handle = (data: unknown) => {
    const payload = data as Partial<KnowledgeDocSavedPayload> & { type?: string }
    if (payload?.type !== 'kb-doc-saved' && payload?.type !== 'kb-doc-created') return
    if (!payload.scope || !payload.itemId) return
    listener({
      type: 'kb-doc-saved',
      scope: payload.scope,
      folderId: Number(payload.folderId) || 0,
      itemId: payload.itemId,
      indexJobId: payload.indexJobId,
    })
  }

  const onWindowMessage = (e: MessageEvent) => {
    if (e.origin !== window.location.origin) return
    handle(e.data)
  }
  window.addEventListener('message', onWindowMessage)

  let bc: BroadcastChannel | null = null
  if (typeof BroadcastChannel !== 'undefined') {
    try {
      bc = new BroadcastChannel(CHANNEL)
      bc.onmessage = (e) => handle(e.data)
    } catch {
      bc = null
    }
  }

  return () => {
    window.removeEventListener('message', onWindowMessage)
    bc?.close()
  }
}
